import { ActionTypes as types } from '../constants'

export function changeDonationAnonymousStatus(donationAnonymousStatus) {
  return {
    type: types.EXTERNAL.CHANGE_DONATION_ANONYMOUS_STATUS,
    data: { donationAnonymousStatus },
  }
}
